import React from 'react';
import Modal, {
  ModalPrimaryButton,
  ModalSecondaryButton,
} from '../../../common/Modal';

const EditGradeModal = ({
  show,
  grade,
  gradeData,
  onGradeDataChange,
  onSave,
  onClose,
  error,
  loading
}) => {

  if (!show || !grade) return null;

  const handleInputChange = (field, value) => {
    onGradeDataChange({
      ...gradeData,
      [field]: value
    });
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      title="Edit grade"
      subtitle={`Current grade: ${grade.gradeValue}`}
      icon="fa-pencil-alt"
      size="lg"
      closeOnBackdrop={!loading}
      closeOnEscape={!loading}
      footer={
        <>
          <ModalSecondaryButton onClick={onClose} disabled={loading}>
            Cancel
          </ModalSecondaryButton>
          <ModalPrimaryButton
            onClick={onSave}
            loading={loading}
            loadingText="Updating..."
            disabled={
              !gradeData.gradeValue ||
              parseFloat(gradeData.gradeValue) < 1 ||
              parseFloat(gradeData.gradeValue) > 6
            }
          >
            <i className="fas fa-save"></i>
            Update grade
          </ModalPrimaryButton>
        </>
      }
    >
        <div>
          <form className="space-y-4 sm:space-y-6">
            <div>
              <label
                htmlFor="editGradeValue"
                className="block text-sm font-semibold text-grey-dusk mb-2"
              >
                <i className="fas fa-star mr-2 text-sunrise-red"></i>
                Grade Value <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                className="input-brand w-full text-base"
                id="editGradeValue"
                placeholder="Enter grade (1.0 - 6.0)"
                min="1"
                max="6"
                step="0.1"
                value={gradeData.gradeValue}
                onChange={(e) => handleInputChange('gradeValue', e.target.value)}
              />
              {gradeData.gradeValue && parseFloat(gradeData.gradeValue) < 4.0 && (
                <div className="mt-2 p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-start space-x-3 animate-fade-in text-left">
                  <i className="fas fa-exclamation-triangle text-amber-500 mt-0.5 flex-shrink-0"></i>
                  <p className="text-sm text-grey-dusk">
                    <span className="font-semibold text-amber-600 block mb-1">Warning</span>
                    Note: Saving a grade below 4.0 will automatically trigger a warning email to the supervisor.
                  </p>
                </div>
              )}
            </div>

            <div>
              <label
                htmlFor="editWeight"
                className="block text-sm font-semibold text-grey-dusk mb-2"
              >
                <i className="fas fa-weight-hanging mr-2 text-sunrise-red"></i>
                Weight
              </label>
              <input
                type="number"
                className="input-brand w-full text-base"
                id="editWeight"
                placeholder="Enter weight"
                min="0.1"
                max="5"
                step="0.1"
                value={gradeData.weight}
                onChange={(e) => handleInputChange('weight', e.target.value)}
              />
              <p className="text-xs sm:text-sm text-gray-600 mt-1">
                Weight for grade calculation (default: 1.0)
              </p>
            </div>

            <div>
              <label
                htmlFor="editDescription"
                className="block text-sm font-semibold text-grey-dusk mb-2"
              >
                <i className="fas fa-clipboard mr-2 text-sunrise-red"></i>
                Description
              </label>
              <input
                type="text"
                className="input-brand w-full text-base"
                id="editDescription"
                placeholder="e.g., Midterm Exam, Project"
                value={gradeData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
              />
            </div>

            <div>
              <label
                htmlFor="editExamDate"
                className="block text-sm font-semibold text-grey-dusk mb-2"
              >
                <i className="fas fa-calendar mr-2 text-sunrise-red"></i>
                Exam Date
              </label>
              <input
                type="date"
                className="input-brand w-full text-base"
                id="editExamDate"
                value={gradeData.examDate}
                onChange={(e) => handleInputChange('examDate', e.target.value)}
              />
            </div>

            {error && (
              <div className="bg-sunrise-red/10 border border-sunrise-red/30 text-sunrise-red px-4 py-3 rounded-lg flex items-start">
                <i className="fas fa-exclamation-triangle mr-2 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm">{error}</span>
              </div>
            )}
          </form>
        </div>
    </Modal>
  );
};

export default EditGradeModal;